import { marked }  from 'marked';
import {
  parseApplicantData,
  parseConversationalAiPayload,
  replaceAiResponseRow,
} from '../../wp_helpers/aiHelpers';

const FieldsHandlers = {
    ckEditor: {
      setData: (selector, data, options) => {
        if (selector) {
          selector.config.autoParagraph = false;
          // Editors gated by notifyOnUserChangeOnly ignore programmatic writes; this event lets
          // them capture the visible AI text into their form state so it is included in saves.
          const notifyAiWrite = () => selector.fire('aiAssistantWrite');
          if(!options.replace){
            if(options.initial)
              selector.setData('', function() { selector.insertHtml(data.replace("\n", "<br>")); notifyAiWrite(); } )
            else {
              selector.insertHtml(data.replace("\n", "<br>"));
              notifyAiWrite();
            }
          }else{
            // setData is async; notify once the replaced data is committed so getData() is fresh.
            selector.setData(marked(data), notifyAiWrite);

            if (typeof options.cb === 'function') {
              options.cb();
            }
          }
        }
      },
    },
    ckEditorTemplate: {
      setData: (selector, data, options) => {
        if (!selector) return;
        const msgData = data.replace("\n", "<br>");
        const renderingKey = Object.keys(options.additionalInfo.rendering)[0];
        const renderingTemplate = options.additionalInfo.rendering[renderingKey].template;
        const placeholder = options.additionalInfo.rendering[renderingKey].placeholder || "{{content}}";

        selector.config.autoParagraph = false;

        const updateMessage = (message) => {
          let ai_message = $(selector).attr("ai_message") || "";
          let newData = ai_message + message;
          $(selector).attr("ai_message", newData);
          let newDataWithTemplate = renderingTemplate.replace(placeholder, newData);
          selector.setData(marked(newDataWithTemplate));
        };

        if (!options.replace) {
          if (options.initial) {
            selector.setData(marked(renderingTemplate), function () {
              updateMessage(msgData);
            });
          } else {
            updateMessage(msgData);
          }
        } else {
          let newDataWithTemplate = renderingTemplate.replace(placeholder, marked(msgData));
          selector.setData(newDataWithTemplate);
          $(selector).attr("ai_message", "");
          if (typeof options.cb === 'function') {
            options.cb();
          }
        }
      },
    },
    text: {
      setData: (selector, data, options) => {
        if (selector) {
          let oldData = ''
          if(!options.replace && !options.initial){
            oldData = selector.text();
          }
          let message = oldData + data;
          selector.html(marked(message));
          let supportGuideLink = options?.additionalInfo?.rendering?.support_guide_link;
          if(supportGuideLink)
            selector.data("supportGuideLink", supportGuideLink)
          if(options.replace && typeof options.cb === 'function'){
            options.cb();
          }
        }
      },
    },
    input: {
      setData: (selector, data, options) => {
        if (selector) {
          let oldData = ''
          if(!options.replace && !options.initial){
            oldData = selector.val();
          }
          let message = oldData + data;
          selector.val(message);

          if(options.replace && typeof options.cb === 'function'){
            options.cb();
          }
        }
      },
    },
    structured_form: {
      setData: (selector, data, options) => {
        if (selector) {
          let application_hash = $("#applicant-attributes").data("applicant_id");
          $.ajax({
            type: "PATCH",
            url: `/api/applications/${application_hash}/forms/generic-cv-ai?detail=full`,
            cache: false,
            dataType: "json",
            contentType: "application/json;charset=UTF-8",
            data: data,
            success: function (formSchema) {
              selector.html("")
              let formHandler = new alpacaForm();
              formHandler.init(null, selector);
              formHandler.updateJsonConfiguration(formSchema);
            },
            error: function (data) {
              console.error(data)
            },
          });
          

          if(options.replace && typeof options.cb === 'function'){
            options.cb();
          }
        }
      },
    },
    conversational_ui_assistant_widget: {
      setData: (selector, data, options) => {
        if (!selector) return;

        const chatApi = selector;

        if (options.replace) {
          chatApi.removeThinkingMessage();
          const { content, annotations } = parseConversationalAiPayload(data);
          chatApi.addMessage({ type: 'ChatContent', content, annotations });

          if (typeof options.cb === 'function') {
            options.cb();
          }
        }
      },
      
      startThinking: (selector) => {
        if (!selector) return;
        const chatApi = selector;
        
        setTimeout(() => {
          chatApi.addMessage({ type: 'thinking' });
        }, 100);
      },
    },
    application_listing: {
      setData: (selector, data, options) => {
        if (selector) {
          if(!options.replace){
            let assistantResponse = $(".application_insights_wrapper").data('assistant-response');
            let assistantResponseData = assistantResponse + data;
            $(".application_insights_wrapper").data('assistant-response', assistantResponseData);
  
            const parsedData = parseApplicantData(assistantResponseData);
            if (parsedData) {
              parsedData.forEach(async (application) => {
                if ($(`.ai-response-row-${application.application_hash}`).data("ai-insight-loading")) {
                  $(`.ai-response-row-${application.application_hash}`).data("ai-insight-loading", false)
                  await replaceAiResponseRow(application);
                }
              });
            }
          }else{
            const parsedData = parseApplicantData(data);
            if (parsedData) {
              $('.ai-response-row').each(async (index, element) => {
                const application = {
                  application_hash: $(element).data("hash"),
                  result: global_i18n("Not enough data available for AI insights.")
                };
                if ($(element).data("ai-insight-loading")) {
                  $(element).data("ai-insight-loading", false)
                  await replaceAiResponseRow(application);
                }
              });
            }
            $(".application_insights_wrapper").data('assistant-response', "");
          }
          if(options.replace && typeof options.cb === 'function'){
            options.cb();
          }
        }
      },
    },
    ai_job_skills_recommendation: {
      setData: (selector, data, options) => {
        if (selector) {
          if (window.aiJobSkillsRecommendation && typeof window.aiJobSkillsRecommendation === 'function') {
            window.aiJobSkillsRecommendation(JSON.parse(data));
          }
          if(options.replace && typeof options.cb === 'function'){
            options.cb();
          }
        }
      },
    },
};

export const setData =  (assistant, data, options) => {
  var message = data;
  const {type, instance} = assistant
  const fieldHandler = FieldsHandlers[type];
  if (fieldHandler && typeof fieldHandler.setData === 'function') {
    let replace = true;
    // The {message, annotations} citation wrapper is a final message — keep replace=true.
    const isCitationWrapper = data && typeof data === "object" && typeof data.message === "string";
    if(typeof data === "object" && !isCitationWrapper){
      const objectKey = Object.keys(data)[0];
      message = data[objectKey]
      replace = false;
    }
    options = {...options, replace}
    fieldHandler.setData(instance(), message, options);
  } else {
    console.error(`Invalid type: ${type}`);
  }
}
